<template>
    <div class="mt-3">
        <div class="w-full text-center">
            <h1 class="text-3xl capitalize">
                Listas de compras registradas para
                {{ selectedMerchant.merchantType | merchantInfo("type") }}
                <strong class="text-theme-primary">
                    {{ selectedMerchant.name }}
                </strong>
                {{ itemsNumber }}
            </h1>
        </div>

        <p class="mt-4 px-4">
            Las lista de compras te dan una visión más clara de las necesidades
            de tu inventario y planificar tus compras de manera más efectiva.
        </p>

        <div class="flex flex-wrap mt-2">
            <div class="flex justify-between flex-col lg:flex-row w-full">
                <div class="my-3 flex items-center justify-around">
                    <app-button relief @click="reloadItems">
                        Consultar 🔎
                    </app-button>

                    <div class="flex">
                        <custom-tooltip border>
                            <app-button
                                v-show="
                                    selected.length &&
                                    $ability.hasPermission('supplyList:Create')
                                "
                                circle
                                icon
                                @click="cloneSelected"
                            >
                                🖨
                            </app-button>

                            <template #tooltip>
                                Clonar lista de compras
                            </template>
                        </custom-tooltip>
                    </div>
                </div>

                <div class="my-3 flex items-center justify-around">
                    <custom-pagination
                        v-model="currentPage"
                        :length="pagesNumber"
                        @input="listItems()"
                    />
                    <tooltip-redirect
                        v-if="$ability.hasPermission('supplyList:Create')"
                        to="/app/supply-lists/new"
                        message="Nueva lista de compras"
                    />
                </div>
            </div>
        </div>

        <div class="w-full mt-2">
            <custom-table
                ref="selectableTable"
                :fields="$data.$fields"
                :items="itemsCurrent"
                :per-page="itemsCurrent.length"
                select-mode="single"
                selectable
                responsive
                outlined
                no-border-collapse
                hover
                class="w-full"
                items-empty-message="Nuestro sistema NO encuentra resultados. Intenta modificar los filtros de búsqueda."
                @flex-selected="onRowSelected"
            >
                <template #cell(id)="data">
                    <div class="flex items-center">
                        <router-link
                            :to="`/app/supply-lists/detail/${data.item.id}?merchantType=${data.item.merchantType}&merchantId=${data.item.merchantId}`"
                            class="text-center btn btn-stack-primary p-1"
                        >
                            <span>
                                {{ data.item.applyAt ? "🟢" : "⚪" }}
                                &nbsp; {{ data.item.id }}
                            </span>
                        </router-link>
                    </div>
                </template>

                <template #cell(concept)="data">
                    <span class="text-center">
                        {{ data.item.concept }}
                    </span>
                </template>

                <template #cell(notifyAt)="data">
                    <span class="text-center">
                        {{
                            data.item.notifyAt
                                ? data.item.notifyAt
                                : "Sin Recordatorio"
                        }}
                    </span>
                </template>

                <template #cell(createdAt)="data">
                    <span class="text-center">
                        {{ data.item.createdAt | date }}
                    </span>
                </template>
            </custom-table>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import CustomTable from "@/components/utils/CustomTable.vue";
import TooltipRedirect from "@/components/utils/TooltipRedirect.vue";

export default {
    name: "SupplyListIndex",
    components: {
        TooltipRedirect,
        CustomTable
    },
    layout: "app",
    data: () => ({
        itemsCurrent: [],
        selected: [],
        $fields: [
            { key: "id", label: "ID", sortable: false },
            { key: "concept", label: "Concepto", sortable: true },
            { key: "supplier", label: "Proveedor", sortable: true },
            { key: "notifyAt", label: "📆 Recordatorio", sortable: true },
            { key: "createdAt", label: "📆 Creación", sortable: true }
        ],

        currentPage: 1,
        pagesNumber: 0,
        itemsNumber: 0
    }),
    computed: {
        ...mapState("supplyLists", ["supplyLists"]),
        ...mapState("commons", ["selectedMerchant"]),
        ...mapGetters("control", ["backgroundColor"])
    },
    watch: {},
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (!(await verifyPagePermission("supplyList:List", "/app", true)))
            return;
        this.listItems(true);
    },
    methods: {
        ...mapActions("supplyLists", ["listSupplyListsPaginated"]),
        async listItems(complete = false) {
            this.isLoading = true;
            this.$loading.show();
            try {
                const { items, pagination } =
                    await this.listSupplyListsPaginated({
                        page: this.currentPage,
                        complete,
                        merchantId: this.selectedMerchant.merchantId,
                        merchantType: this.selectedMerchant.merchantType
                    });
                this.itemsCurrent = items;
                if (pagination) {
                    this.itemsNumber = pagination.itemsNumber;
                    this.pagesNumber = pagination.pagesNumber;
                }
                this.$loading.hide();
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async reloadItems() {
            this.currentPage = 1;
            await this.listItems(true);
        },
        onRowSelected(items) {
            this.selected = items;
        },
        clearSelected() {
            this.$refs.selectableTable.clearSelected();
            this.selected = [];
        },
        cloneSelected() {
            window
                .open(
                    `/app/supply-lists/clone/${this.selected[0].id}`,
                    "_blank"
                )
                .focus();
        }
    }
};
</script>
